<template>
  <div class="detail-padding padding-nav">
    <el-button @click="goback" type="text" class="upper" style="margin-bottom:0.16rem;" icon="el-icon-d-arrow-left">Go
      back</el-button>
    <!-- <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class=".el-input__inner">Initiate Proposal</div>
      </div>
    </div> -->
    <div class="vote-card">
      <div class="vote-card-head">Initiate Proposal</div>
      <div>
        <el-form :model="pageData" ref="voteForm" class="vote-form page-form" label-position="top" :rules="rules">
          <el-form-item prop="title" label="Title" :rules="[
            {
              required: true,
              message: 'Please fill in',
              trigger: 'blur'
            }
          ]">
            <el-input v-model="pageData.title" placeholder="Please fill in, no more than 100 characters"
              maxlength="100" />
          </el-form-item>
          <el-form-item prop="description" label="Description" :rules="[
            {
              required: true,
              message: 'Please fill in',
              trigger: 'blur'
            }
          ]">
            <!-- <el-input
              type="textarea"
              v-model="pageData.desc"
              placeholder="Please fill in, no more than 10000 characters"
              maxlength="10000"
            /> -->
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
            <Editor id="textarea1" style="height: 3rem; overflow-y: hidden;" v-model="pageData.description"
              :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
          </el-form-item>
          <div class="spaceLeft vote-form-item">
            <div>Duration</div>
            <el-tooltip class="item" effect="dark" :content="duration.toString()" placement="top">
                <span style="color:#fff">{{duration.toFixed(4)}} Day</span> 
              </el-tooltip> 
          </div>
          <el-form-item prop="discussionUrl" label="Discussion">
            <el-input v-model="pageData.discussionUrl" placeholder="eg: https://medium.com/@treasurenet_io" />
          </el-form-item>

          <el-form-item>
            <div class="spaceCenter" style="margin-top:0.4rem;">
              <el-button class="btn-cancel" @click="cancel()" style="min-width:1.6rem">Cancel
              </el-button>
              <el-button class="common-btn-blue-sm" @click="next()" style="min-width:1.6rem">
                Next
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <createDialog ref="createDialog" @success="success" />

  </div>
</template>

<script>
import createDialog from "./createDialog.vue";
import "@wangeditor/editor/dist/css/style.css";
import { i18nChangeLanguage } from "@wangeditor/editor";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { createProposal } from "@/api/dao.js";


i18nChangeLanguage("en");
export default {
  components: {
    createDialog,
    Editor,
    Toolbar
  },
  data() {
    return {
      pageData: {
        title: undefined,
        description: undefined,
        discussionUrl: undefined
      },
      rules: {
        value: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateInput
          }
        ]
      },
      duration: 0,
      editor: null,
      html: "",
      toolbarConfig: {
        toolbarKeys: [
          "bold",
          "underline",
          "italic",
          "through",
          "code",
          "sub",
          "sup",
          "clearStyle",
          "color",
          "bgColor",
          "fontSize",
          // "fontFamily",
          // "indent",
          // "delIndent",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "justifyJustify",
          "lineHeight",
          // "insertImage",
          // "deleteImage",
          // "editImage",
          // "viewImageLink",
          // "imageWidth30",
          // "imageWidth50",
          // "imageWidth100",
          // "divider",
          // "emotion",
          // "insertLink",
          // "editLink",
          // "unLink",
          // "viewLink",
          // "codeBlock",
          // "blockquote",
          // "headerSelect",
          // "header1",
          // "header2",
          // "header3",
          // "header4",
          // "header5",
          // "todo",
          // "redo",
          // "undo",
          // "fullScreen",
          // "enter",
          // "bulletedList",
          // "numberedList",
          // "insertTable",
          // "deleteTable",
          // "insertTableRow",
          // "deleteTableRow",
          // "insertTableCol",
          // "deleteTableCol",
          // "tableHeader",
          // "tableFullWidth",
          // "insertVideo",
          // "uploadVideo",
          // "editVideoSize",
          // "uploadImage",
          // "codeSelectLang"
        ]
      },
      editorConfig: { placeholder: "Please fill in...", maxLength: 10000 },
      mode: "default" // or 'simple'
    };
  },
  computed: {},
  methods: {
    next() {
      const desc = this.editor.getText();
      if (desc.length <= 0 ) {
        this.$message.error("Please fill in the description, no more than 10000 characters");
        return;
      }
      this.$refs.voteForm.validate(valid => {
        if (valid) {
          // createProposal(this.pageData).then(res => {
          //   this.$refs.createDialog.open({
          //     pageData: this.pageData
          //   });
          // })
          this.$refs.createDialog.open({
            pageData: this.pageData
          });
        } else {
          return false;
        }
      });
    },
    success() {
      this.goback();
    },
    cancel() {
      this.goback();
    },
    goback() {
      this.$router.push("/Governance/proposal");
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
      // wangEditor api https://www.wangeditor.com/v5/menu-config.html
      // console.log("all menu keys", editor.getAllMenuKeys());
    }
  },
  async mounted() {
    this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
    this.votingPeriod = await this.contractDao.methods.votingPeriod().call({from:this.$store.getters.metaMaskObj.account})
    this.duration = (this.votingPeriod *  5 / 86400)
  },
  watch: {}
};
</script>

<style scoped lang="scss">
 
  /deep/ .w-e-select-list, /deep/ .w-e-select-list ul .selected {
background: rgba(255,255,255,0.1);
color: #DCE0E7;
  }

 /deep/ .w-e-bar, /deep/ .w-e-text-container, /deep/ .el-input__inner, /deep/ .w-e-select-list ul li:hover{
  background: rgba(255,255,255,0.1);
  color: #DCE0E7;
  border: 1px solid rgba(255,255,255,0.2);
  
}
.btn-cancel{
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: #FFFFFF;
}
.duration{
  color: #FFFFFF!important;
}
.vote-card {
  background: #ffffff;
  border-radius: 0.04rem;
  min-height: 60vh;
  padding-bottom: 0.4rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
  .vote-card-head {
    border-bottom: 0.01rem solid rgba($color: #fff, $alpha: 0.1);
    font-size: 0.22rem;
    color: #fff;
    font-weight: bold;
    line-height: 0.88rem;
    height: 0.88rem;
    text-align: center;
  }

  .vote-form {
    width: 80%;
    margin: 0.45rem auto 0 auto;
    font-size: 0.2rem;

    /deep/ .el-form-item__label {
      color: #6b6b6b;
      font-weight: normal;
      font-size: 0.2rem;
      padding-bottom: 0;
    }

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item {
      margin-bottom: 0.32rem;
    }

    .el-input--medium,
    /deep/ .el-select-dropdown__item {
      font-size: 0.2rem !important;
    }

    .vote-form-item {
      margin-bottom: 0.32rem;
      padding-top: 0.12rem;

      div {
        margin-right: 0.12rem;
        color: #6b6b6b;
      }

      span {
        color: #1f1f1f;
      }
    }
  }
}

.form-desc {
  color: #666;
  position: absolute;
  left: 101%;
  white-space: nowrap;
  top: 0;
  font-size: 0.15rem;
}
</style>
